export const getUserName = (state) => state.user.name;
export const user = (state) => state.user;
export const loggedIn = (state) => state.loggedIn;
export const loginError = (state) => state.loginError;
export const isAdmin = (state) => state.user.level === 'admin';
